import React from "react";

import { Schema } from "../../../../../../../../redux/constants/OrdersPage/order";
import { UseCreateFormReturn } from "../../../../../../../../hooks/useCreateForm";
import { useCheckFlagAccessControl } from "../../../../../../../../hooks";
import {
	StyledColumn,
	StyledRow,
} from "../../../../../../../../components/common";
import { Tab } from "../../types/Tab";
import { TabAccessNames, TabKeys } from "../../constants/access";

import IntercityRoadTrip from "./IntercityRoadTrip";
import RateIncludePickupCost from "./RateIncludePickupCost";
import Hourly from "./Hourly";
import IncludePickupMargin from "./IncludePickupMargin";
import Taximeter from "./Taximeter";

interface OrderRideInformationProps {
	form: UseCreateFormReturn<Schema>;
	tab: Tab;
	disabled: boolean;
}

const OrderRideInformation: React.FC<OrderRideInformationProps> = ({
	disabled,
	form,
	tab,
}) => {
	const checkFlagAccessControl = useCheckFlagAccessControl(TabAccessNames);

	return (
		<StyledRow bgC="#F6F6F6">
			<StyledColumn
				flex={{ wrap: "wrap" }}
				gap="2px 12px"
				h="44px"
				p="2px 12px"
				justify="start"
				alignItems="start"
				bgC="#F6F6F6"
				w="max-content"
			>
				<RateIncludePickupCost
					disabled={
						disabled || !checkFlagAccessControl[TabKeys.AUTO_SUPPLY]
					}
					form={form}
				/>
				<IntercityRoadTrip
					disabled={
						disabled || !checkFlagAccessControl[TabKeys.OUT_OF_TOWN]
					}
					form={form}
				/>
				<IncludePickupMargin
					disabled={
						disabled || !checkFlagAccessControl[TabKeys.SUPPLY]
					}
					form={form}
				/>
				<Hourly
					disabled={
						disabled || !checkFlagAccessControl[TabKeys.HOURLY]
					}
					form={form}
				/>
				<Taximeter
					disabled={
						disabled || !checkFlagAccessControl[TabKeys.TAXIMETER]
					}
					form={form}
					tab={tab}
				/>
			</StyledColumn>
		</StyledRow>
	);
};

export default OrderRideInformation;
